
import { YoungQuestion } from '@/types/personality';
import { disconnectionQuestions } from './disconnectionQuestions';
import { impairedAutonomyQuestions } from './impairedAutonomyQuestions';
import { impairedLimitsQuestions } from './impairedLimitsQuestions';
import { otherDirectednessQuestions } from './otherDirectednessQuestions';
import { overvigilanceQuestions } from './overvigilanceQuestions';

// Combine all questions from different domains
export const youngSchemasQuestions: YoungQuestion[] = [
  ...disconnectionQuestions,
  ...impairedAutonomyQuestions,
  ...impairedLimitsQuestions,
  ...otherDirectednessQuestions,
  ...overvigilanceQuestions
];
